import { ReactNode } from 'react';

export type TooltipSeverity = 'error' | 'warning' | 'remark' | 'success';

export type TooltipItem = {
    key: string;
    text: ReactNode;
    severity: TooltipSeverity;
};

const severityBorderClass: Record<TooltipSeverity, string> = {
    error: 'tw-border-l-error',
    warning: 'tw-border-l-warning',
    remark: 'tw-border-l-gray-300',
    success: 'tw-border-l-success',
};

export const TooltipList = ({ items }: { items: TooltipItem[] }) => {
    if (!items.length) return null;

    return (
        <ul className="tw-m-0 tw-max-h-60 tw-list-none tw-space-y-2 tw-overflow-y-auto tw-p-0">
            {items.map(({ key, text, severity }) => (
                <li
                    key={key}
                    className={`!tw-border-r-0 tw-border-b-0 tw-border-t-0 !tw-border-l-[5px] tw-border-solid tw-pl-2 tw-text-t-sm ${severityBorderClass[severity]}`}
                >
                    {text}
                </li>
            ))}
        </ul>
    );
};
